import React from 'react';
import { InfoIconStyles as S } from './InfoIcon.styles';
import { ReactComponent as Info } from '@img/ysp/icon-info.svg';
const InfoIcon = (props) => {
    return (React.createElement(S.Container, { ...props },
        React.createElement(S.InfoIcon, null,
            React.createElement(Info, null))));
};
export default InfoIcon;
